
































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addPlayer, queryPlayerById, updatePlayer } from '@/api/player.ts'
import { addGift, queryGiftById, updateGift } from '@/api/gift.ts'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private title = '新建礼物'
  private imageUrl: string = ''
  private actionType: string = 'add'
  private vueRest = '1'
  private index = 0
  private inputStyle = { flex: 1 }
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    image: '',
    name: '',
    price: '',
    hot: ''
  }

  get rules() {
    return {
      image: {
        required: true,
        message: '礼物图片不能为空'
      },
      name: {
        required: true,
        message: '礼物名称不能为空'
      },
      price: {
        required: true,
        message: '礼物价格不能为空'
      },
      hot: {
        required: true,
        message: '礼物热度不能为空'
      }
    }
  }

  created() {
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    if (this.$route.query.id) {
      this.title = '修改礼物信息';
      this.init();
    }
  }

  private async init() {
    queryGiftById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.imageUrl = res.data.data.image
        this.ruleForm = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.image) return this.$message.error('礼物图片不能为空')
        if (!this.ruleForm.name) return this.$message.error('礼物名称不能为空')
        if (!this.ruleForm.payName) return this.$message.error('支付名称不能为空')
        if (!this.ruleForm.price) return this.$message.error('礼物价格不能为空')
        if (!this.ruleForm.hot) return this.$message.error('礼物热度不能为空')
        let params: any = { ...this.ruleForm }
        // let params: any = {}
        // // params.flavors = this.dishFlavors
        // params.image = this.ruleForm.image
        // params.name = this.ruleForm.name
        // params.type = 1
        // params.price *= 100
        if (this.actionType == 'add') {
          delete params.id
          addGift(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('礼物新建成功！')
                  this.$router.push({ path: '/competition/giftManage' })
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          params.number = this.ruleForm.number
          updateGift(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/competition/giftManage' })
                this.$message.success('礼物信息修改成功！')
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.image = value
  }
}
